import { createContext, useContext, useState } from "react";

const DHLShipmentFormContext = createContext();

export const initialValues = {
  details: {
    from: {
      address: {
        postalCode: "",
        city: "",
        residentialAddress: false,
        country: "GB",
        address: {
          one: "",
          two: "",
          // three: "",
        },
      },
      contact: {
        name: "",
        companyName: "Kidswear Collective",
        businessContact: false,
        email: "",
        smsEnabled: false,
        phone: [
          {
            type: "mobile",
            code: "+44",
            number: "",
          },
        ],
      },
      registrationNumbers: [],
    },
    to: {
      address: {
        postalCode: "NW4 4BW",
        city: "London",
        residentialAddress: false,
        country: "GB",
        address: {
          one: "KIDSWEAR COLLECTIVE Unit 4",
          two: "Propeller Way",
          // three: "",
        },
      },
      contact: {
        name: "Anthony",
        companyName: "Kidswear Collective",
        businessContact: true,
        email: "Anthony@kidswearcollective.com",
        smsEnabled: false,
        phone: [
          {
            type: "mobile",
            code: "+44",
            number: "7515360049",
          },
        ],
      },
      registrationNumbers: [],
    },
  },
  request: {
    requestType: "",
    description: "",
  },
  contentDetails: {
    packages: [
      {
        name: "",
        quantity: 1,
        weight: 5,
        dimensions: {
          length: 50,
          width: 50,
          height: 50,
        },
      },
    ],
  },
  dateAndTime: "",
  type: "drop-off",
  dropoff: {},
  requested_by: "",
  bagIds: [],
};

export const ShipmentFormProvider = ({ children }) => {
  const [formData, setFormData] = useState(initialValues);
  const [shipmentCreatedData, setShipmentCreatedData] = useState({});

  const [selectFromCountry, setSelectFromCountry] = useState({
    label: "United Kingdom",
    value: "GB",
  });
  const [selectFromCountryCode, setSelectFromCountryCode] = useState({
    label: "+44",
    value: "+44",
  });
  const [selectToCountry, setSelectToCountry] = useState({
    label: "United Kingdom",
    value: "GB",
  });
  const [selectToCountryCode, setSelectToCountryCode] = useState({
    label: "+44",
    value: "+44",
  });

  const updateFormData = (newData) => {
    setFormData((prev) => ({ ...prev, ...newData }));
  };

  return (
    <DHLShipmentFormContext.Provider
      value={{
        formData,
        updateFormData,
        shipmentCreatedData,
        setShipmentCreatedData,
        selectFromCountry,
        setSelectFromCountry,
        selectFromCountryCode,
        setSelectFromCountryCode,
        selectToCountry,
        setSelectToCountry,
        selectToCountryCode,
        setSelectToCountryCode,
      }}
    >
      {children}
    </DHLShipmentFormContext.Provider>
  );
};

export const useShipmentForm = () => useContext(DHLShipmentFormContext);
